import {HttpInterface} from "@/modern/core";
import axios, {type Axios} from "axios";
import {UrlUtils} from "./UrlUtils";
export class AxiosHttpClient implements HttpInterface {
    #axiosInstance: Axios; // Replace with actual Axios instance type
    static #instance: Record<string, AxiosHttpClient> = {};
    #inernalName: string = 'AxiosHttpClient';
    baseURL: string;
    private customHeaders: Record<string, string> = {}

    constructor(url:string, name?: string) {
        this.baseURL = url;
        if (name) {
            this.#inernalName = name;
        }
        this.setDefaultHeaders()
        this.#axiosInstance = axios.create(
            {
                baseURL: url
            }
        )
    }

    static getInstance<T extends typeof AxiosHttpClient>(this: T) {
        const className = 'default';
        if(!AxiosHttpClient.#instance[className]) {
            const urlApi = UrlUtils.instance(import.meta.env.VITE_APP_BUSSOLA_API_URL)
                .generateURL('pedagogico/v1')
            AxiosHttpClient.#instance[className] = new this(urlApi, className)
        }
        return AxiosHttpClient.#instance[className] as InstanceType<T>
    }

    static getAtendimentoInstance<T extends typeof AxiosHttpClient>(this: T) {
        const className = 'atendimento';
        if(!AxiosHttpClient.#instance[className]) {
            const urlApi = UrlUtils.instance(import.meta.env.VITE_APP_BUSSOLA_API_ATENDIMENTO_URL)
                .generateURL('config/v1')
            AxiosHttpClient.#instance[className] = new this(urlApi, className)
        }
        return AxiosHttpClient.#instance[className] as InstanceType<T>
    }

    get clientName(): string {
        return this.#inernalName
    }

    private setDefaultHeaders() {
        const token = this.getToken();
        if (token) {
            this.customHeaders['Authorization'] = `Bearer ${token}`;
        } else {
            delete this.customHeaders['Authorization'];
        }
    }

    private getToken(): string | null {
        const jsonToken = localStorage.getItem('token');
        if (jsonToken) {
            try {
                const token = JSON.parse(jsonToken);
                return token.token || null;
            } catch (e) {
                console.error("Error parsing token from localStorage:", e);
                return null;
            }
        }
        return null;
    }

    setHeader(name: string, value: string) {
        this.customHeaders[name] = value;
    }

    async get<T>(url: string): Promise<T> {
        const headers = this.customHeaders
        this.setDefaultHeaders()
        return this.#axiosInstance.get(url, {headers})
    }

    async post<T>(url: string, data: any): Promise<T> {
        const headers = this.customHeaders
        this.setDefaultHeaders()
        return this.#axiosInstance.post(url, data, {headers})
    }

    async put<T>(url: string, data: any): Promise<T> {
        const headers = this.customHeaders
        this.setDefaultHeaders()
        return this.#axiosInstance.put(url, data, {headers})
    }

    async patch<T = any>(url: string, data?: Record<string, any>): Promise<T> {
        const headers = this.customHeaders
        this.setDefaultHeaders()
        return this.#axiosInstance.patch(url, data, {headers});
    }

    async delete<T>(url: string): Promise<T> {
        const headers = this.customHeaders
        this.setDefaultHeaders()
        return this.#axiosInstance.delete(url, {headers});
    }
}